import I18n from 'i18n-js'
import React from 'react'
import { Form } from 'react-bootstrap'
import { useSelector } from 'react-redux'

const EventVictims = ({ event, onChange, disabled }) => {
  const { victims } = useSelector((state) => state.resourceReducer)

  // We handle both formats here: either an array of IDs like [1,2,3]
  // or an array of objects like [{id:1}, {id:2}, ...]
  const selectedVictimIds = (event.victims || []).map((victim) => victim.id ?? victim)

  return (
    <div>
      <p className="input-text-title mb-0">{I18n.t('EventVictim')}</p>
      <div className="row no-gutters">
        {victims.map((victim) => (
          <Form.Check
            key={victim.id}
            className="mr-0 col-12"
            value={selectedVictimIds.includes(victim.id)}
            checked={selectedVictimIds.includes(victim.id)}
            onChange={() => onChange(victim.id)}
            inline
            label={victim.label}
            type="checkbox"
            id={victim.id}
            disabled={disabled}
          />
        ))}
      </div>
    </div>
  )
}

export default EventVictims
